<template>
  <div v-if="sidebarMenu">
    <ul v-if="isDesktop" class="-mt-6 flex flex-col pl-8 text-sm uppercase">
      <li
        v-for="page in sidebarMenu"
        :key="page.slug"
        class="border-b-[1px] border-gray-lighten1 py-6"
      >
        <NuxtLink
          :to="`/${page.slug}`"
          class="title relative text-slate-lighten4 hover:text-blue"
        >
          <UiIcon
            v-if="page.slug === pageSlug"
            icon="checkmark"
            class="absolute -left-8 top-0 text-blue"
          ></UiIcon>

          {{ page.text }}
        </NuxtLink>
      </li>
    </ul>

    <UiSelect
      v-else
      :model-value="pageSlug"
      :options="sidebarMenu"
      item-id="slug"
      item-text="text"
      @update:model-value="navigateToPage"
    ></UiSelect>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('lg');
const route = useRoute();
const router = useRouter();

const sidebarMenu = computed(() =>
  props.data?.menu?.filter(
    ({ active }: { active: boolean }) => active !== false,
  ),
);

const pageSlug = ref(route.params.slug as string);

const navigateToPage = (slug: string) => {
  pageSlug.value = slug;
  router.push(slug);
};
</script>
